import React from "react";
import { useModal } from "../../context/ModalContext";
import TermsContent from "../TermsContent";
import PrivacyContent from "../PrivacyContent";

const ModalTerms = ({ data }) => {
  const { closeModal } = useModal();

  const title = data?.title || "Termos e Condições";

  return (
    <div className="ModalTerms" style={{ backgroundColor: "#E6DDCE" }}>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-11">
            <h3 className="text-center text-uppercase mb-3">
              <strong>{title}</strong>
            </h3>

            <div
              className="w-100"
              style={{
                height: "70vh",
                borderRadius: "12px",
                overflow: "auto"
              }}
            >
              <div
                className="generalTerms termsConditions"
                style={{
                  background: "transparent",
                  backgroundImage: "none",
                  padding: 0,
                }}
              >
                {data?.type === "privacy" ? <PrivacyContent /> : <TermsContent />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalTerms;
